import React from 'react';
import { contentLibraryResults } from '../../data/mockData';

const ContentMatchView = ({ state }) => {
  const { setWorkflowStep } = state;

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 24, fontWeight: '600', color: '#f3f4f6' }}>Content Library Match</h2>
          <p style={{ margin: '8px 0 0', color: '#9ca3af', fontSize: 14 }}>
            Existing content analysis {'\u2022'} Gap identification
          </p>
        </div>
        <button
          onClick={() => setWorkflowStep(3)}
          style={{
            backgroundColor: '#6366f1',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: 8,
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: 14
          }}
        >
          Run Scoring Model {'\u2192'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Related Existing Content</h3>
          <div style={{ display: 'grid', gap: 12 }}>
            {contentLibraryResults.existingContent.map((content, idx) => (
              <div key={idx} style={{ padding: 12, backgroundColor: '#252540', borderRadius: 8 }}>
                <div style={{ fontSize: 14, fontWeight: '500', color: '#f3f4f6', marginBottom: 8 }}>{content.title}</div>
                <div style={{ display: 'flex', gap: 16, fontSize: 12, color: '#9ca3af' }}>
                  <span>Performance: <span style={{ color: content.performance === 'High' ? '#10b981' : '#f59e0b' }}>{content.performance}</span></span>
                  <span>Age: {content.age}</span>
                  <span>Views: {content.pageviews}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 24, border: '1px solid #2d2d44' }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Gap Analysis</h3>
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ fontSize: 13, color: '#9ca3af' }}>Current Coverage</span>
              <span style={{ fontSize: 14, fontWeight: '500', color: '#f59e0b' }}>{contentLibraryResults.gapAnalysis.coverage}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13, color: '#9ca3af' }}>Opportunity Level</span>
              <span style={{ fontSize: 14, fontWeight: '500', color: '#10b981' }}>{contentLibraryResults.gapAnalysis.opportunity}</span>
            </div>
          </div>
          <div style={{ borderTop: '1px solid #2d2d44', paddingTop: 16 }}>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8, textTransform: 'uppercase' }}>Identified Gaps</div>
            {contentLibraryResults.gapAnalysis.gaps.map((gap, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ color: '#ef4444' }}>{'\u25CB'}</span>
                <span style={{ fontSize: 13, color: '#d1d5db' }}>{gap}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentMatchView;
